import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './RecruitmentDetail.module.scss';
import LoadingScreen from '~/components/LoadingScreen';
import PushNotification from '~/components/PushNotification';
import DateTime from '~/components/DateTime';
import Title from '~/components/Title';
import { getActivityById } from '~/services/activityService';
import { Helmet } from 'react-helmet';

const cx = classNames.bind(styles);

const RecruitmentDetail = () => {
    const { id } = useParams();
    const [recruitmentDetail, setRecruitmentDetail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRecruitmentDetail = async () => {
            try {
                const data = await getActivityById(id);
                setRecruitmentDetail(data);
            } catch (error) {
                setError(error);
                console.error('Error fetching recruitment detail:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRecruitmentDetail();
    }, [id]);

    if (error) {
        const errorMessage = error.response ? error.response.data.message : 'Network Error';
        return <PushNotification message={errorMessage} />;
    }

    if (loading) {
        return <LoadingScreen />;
    }

    return (
        <article className={cx('wrapper')}>
            <Helmet>
                <title>{recruitmentDetail.title} | TDC DAKLAK</title>
                <meta name="description" content={recruitmentDetail.summary} />
                <meta name="keywords" content="hoạt động, TDC DAKLAK, chi tiết hoạt động" />
            </Helmet>
            <div className={cx('inner')}>
                <div className={cx('header')}>
                    <Title text={`${recruitmentDetail.title}`} className={cx('title')} />
                </div>
                <div className={cx('content')} dangerouslySetInnerHTML={{ __html: recruitmentDetail.content }} />
                <DateTime
                    timestamp={recruitmentDetail.createdAt}
                    views={recruitmentDetail.views}
                    showDate={true}
                    showTime={true}
                    showViews={false}
                />
            </div>
        </article>
    );
};

export default RecruitmentDetail;
